import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { EnumSiNoTodos, ListSiNo, ListSiNoTodos, Tc } from 'src/app/components/core/_infrastructure/types/common';
import { NgSelectComponent } from '@ng-select/ng-select';
import { PeriodoDatosCaCamViewModel, ActivaSelected, CASelectedViewModel } from '../../solicitudes/buscador-solicitud-cam.types';
import { FilterSearchingRecintoUnidadInspeccion } from '../buscador-unidad-inspeccion.types';
import { PeriodoCamItemViewModel } from 'src/app/components/_mantenimiento/campanias/periodos/datosbasicos/periodocam.types';
@Component({
    selector: 'app-buscador-unidad-inspeccion-filter',
    templateUrl: './buscador-unidad-inspeccion-filter.component.html',
    styleUrls: ['./buscador-unidad-inspeccion-filter.component.scss'],
})
export class BuscadorUnidadInspeccionFilterComponent extends ComponentBase implements OnInit, OnChanges {
    @Input() formGroup: FormGroup;
    @Input() lastFilter: FilterSearchingRecintoUnidadInspeccion;
    @Input() campanias: Tc[];
    @Input() periodos: PeriodoCamItemViewModel[];
    @Input() CAs: PeriodoDatosCaCamViewModel[];
    @Input() tiposSolicitud: Tc[];
    @Input() estadosUnidadInspeccion: Tc[];
    @Input() EAs: Tc[];
    @Input() provincias: Tc[];
    @Input() municipios: Tc[];
    @Input() operadores: Tc[];
    @Output() search = new EventEmitter<FilterSearchingRecintoUnidadInspeccion>();
    @Output() cleanForm = new EventEmitter<any>(); // Informa que el formulario se ha reseteado
    @Output() activaSelected = new EventEmitter<ActivaSelected>();
    @Output() campaniaSelected = new EventEmitter<number>();
    @Output() periodoSelected = new EventEmitter<number>();
    @Output() caSelected = new EventEmitter<CASelectedViewModel>();
    @Output() provinciaSelected = new EventEmitter<number>();
    @Output() eaSelected = new EventEmitter<number>();
    @Output() tipoSolicitudSelected = new EventEmitter<number>();

    @ViewChild('selectEstado') selectEstado: NgSelectComponent;

    isCollapsed = false;
    entidadAuditoraEnabledForCA = false;
    listSiNoTodos = ListSiNoTodos;
    listSiNo = ListSiNo;

    constructor(
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.patchForm();
        this.recoverLastSearch();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.formGroup) {
            return;
        }
        if (changes?.lastFilter?.currentValue && this.lastFilter) {
            this.patchForm();
        }
        if (changes?.CAs?.currentValue) {
            let IdCa = 0;
            if (this.isCA) {
                IdCa = this.loggedInUser?.TwUsuarioCa?.IdCa || 0;
            } else {
                IdCa = this.lastFilter?.IdCA || 0;
            }

            if (IdCa === null || IdCa === 0) {
                return;
            }
            const selectedCA: PeriodoDatosCaCamViewModel | undefined = this.CAs?.find(x => x.IdCa == IdCa);
            this.entidadAuditoraEnabledForCA = selectedCA?.EntidadAuditora || false;
        }
    }

    /**
     * Recover last search from the previous payload
     */
    private recoverLastSearch(): void {
        if (this.lastFilter) {
            this.patchForm();

            setTimeout(() => {
                this.onSearch(null);
            }, 200);
        }
    }

    private patchForm(): void {
        this.formGroup.patchValue({
            Activa: this.lastFilter?.Activa || EnumSiNoTodos.TODOS,
            IdCampania: this.lastFilter?.IdCampania || null,
            IdPeriodo: this.lastFilter?.IdPeriodo || null,
            IdCA: this.lastFilter?.IdCA || null,
            IdEntidadAuditora: this.lastFilter?.IdEntidadAuditora || null,
            CodigoUhc: this.lastFilter?.CodigoUhc || '',
            NumeroRegistro: this.lastFilter?.NumeroRegistro || '',
            RegistroSanitario: this.lastFilter?.RegistroSanitario || '',
            IdTipoSolicitudCam: this.lastFilter?.IdTipoSolicitudCam || null,
            IdEstadoUnidadInspeccion:
                this.lastFilter?.IdEstadoUnidadInspeccion || this.lastFilter?.IdEstadoUnidadInspeccion === 0 ? this.lastFilter?.IdEstadoUnidadInspeccion : null,
            IdOperador: this.lastFilter?.IdOperador || null,
            IdProvincia: this.lastFilter?.IdProvincia || null,
            IdMunicipio: this.lastFilter?.IdMunicipio || null,
            Poligono: this.lastFilter?.Poligono || null,
            Parcela: this.lastFilter?.Parcela || null,
            Recinto: this.lastFilter?.Recinto || null,
            // NOT VISIBLE
            IdUsuario: this.lastFilter?.IdUsuario || 0,
        });

        /*
        if (this.lastFilter.IdProvincia) {
            // Para recargar el desplegable de Municipios, vinculadas a la Provincia.
            this.onSelectProvincia(null);
        }
        if (this.lastFilter.IdMunicipio) {
            this.setIdMunicipio(this.lastFilter.IdMunicipio);
        }
        */

        this.form = this.formGroup; // componentBase uses this.form

        this.formGroup.markAsDirty();
    }

    /**
     * Manejador del evento para limpiar el formulario.
     * @param $event any Evento javascript
     */
    resetForm($event: any): void {
        $event.stopPropagation();
        this.formGroup.patchValue({
            Activa: EnumSiNoTodos.TODOS,
            IdCampania: null,
            IdPeriodo: null,
            IdCA: null,
            IdEntidadAuditora: null,
            CodigoUhc: '',
            NumeroRegistro: '',
            RegistroSanitario: '',
            IdTipoSolicitudCam: null,
            IdEstadoUnidadInspeccion: null,
            IdOperador: null,
            IdProvincia: null,
            IdMunicipio: null,
            Poligono: null,
            Parcela: null,
            Recinto: null,
            // NOT VISIBLE
            IdUsuario: 0, // Este campo no se rellena en el front. Se mantiene por compatibilidad de tipos con el core.
        });

        this.formGroup.markAsPristine();

        this.searchingButton = false;
        this.isCollapsed = false;
        this.entidadAuditoraEnabledForCA = false;

        this.cleanForm.emit();
    }

    /**
     * Manejador del evento de búsqueda.
     * En la búsqueda desde recoverLastSearch $event será nulo, por lo tanto no se resetean los valores asociados al paginador.
     * @param $event any Evento Javascript
     */
    onSearch($event: any): void {
        $event?.stopPropagation();
        this.searchingButton = true;
        this.isCollapsed = true;

        const payload: FilterSearchingRecintoUnidadInspeccion = {
            ...this.form.getRawValue(),
            PageNumber: this.lastFilter?.PageNumber || 0,
            Asc: this.lastFilter?.Asc || 0,
            OrderBy: this.lastFilter?.OrderBy || '',
        };

        this.search.emit(payload);
    }

    /**
     * Este método invoca al manejador que gestiona el cambio del valor "Activa"
     * @param $event Puede ser el objeto que se construye al hacer click en el botón o el valor que se obtiene
     * desde el lastFilter, cuando se invoca a éste método programáticamente desde el wrapper.
     */
    onChangeActiva($event: any, cleanDependent?: boolean): void {
        let activaSelected = new ActivaSelected();

        if (typeof $event == 'object') {
            activaSelected.Activa = $event.value || EnumSiNoTodos.TODOS;
            activaSelected.cleanDependent = true;
        } else {
            activaSelected.Activa = $event;
            activaSelected.cleanDependent = cleanDependent;
        }
        this.activaSelected.emit(activaSelected);
        this.setCampania(null);
        this.cleanDependentOnCampania();
    }

    /**
     * Manejador que permite emitir el evento que indica que ha cambiado la Campaña.
     * @param idCampania number
     */
    onSelectCampania(idCampania: number): void {
        this.campaniaSelected.emit(idCampania);
        this.cleanDependentOnCampania();
    }

    /**
     * Este manejador permite emitir el evento que indica que el periodo ha sido seleccionado.
     * Este método también se invocará al recargar la consulta. Podrá venir a null, en ése caso se cargaría el listado completo de CAs.
     * @param idPeriodo number | null
     */
    onSelectPeriodo(idPeriodo: number | null): void {
        this.periodoSelected.emit(idPeriodo!);
        this.cleanDependentOnPeriodo();
    }

    /**
     * Manejador del evento de selección de una CA en el desplegable.
     * Ignoramos el IdPeriodo que viene en el parámetro y lo tomamos del form.
     * @param $event PeriodoDatosCaCamViewModel | undefined
     */
    onSelectComunidadAutonoma(caSelected: PeriodoDatosCaCamViewModel | undefined): void {
        this.entidadAuditoraEnabledForCA = caSelected?.EntidadAuditora || false;
        this.setEntidadAuditora(null);
        this.cleanDependentOnCA();

        const caSelectedVM = new CASelectedViewModel();
        caSelectedVM.idCA = caSelected?.IdCa;
        caSelectedVM.idPeriodo = this.form.controls.IdPeriodo.value;

        this.caSelected.emit(caSelectedVM);
    }

    /**
     * Manejador del evento de selección de una Provincia en el desplegable.
     * Ignoramos el valor que viene en el parámetro y lo tomamos del form.
     * @param $event Id y descripción de la provincia seleccionado
     */
    onSelectProvincia($event: any): void {
        const idProvincia = this.form.controls.IdProvincia.value;
        this.provinciaSelected.emit(idProvincia);
        this.setIdMunicipio(null);
    }

    onSelectEntidadAuditora(id: number | null): void {
        this.eaSelected.emit(id!);
    }

    onSelectTipoSolicitud(id: number | null): void {
        this.tipoSolicitudSelected.emit(id!);
    }

    private cleanDependentOnCampania(): void {
        this.setPeriodo(null);
        this.cleanDependentOnPeriodo();
    }

    private cleanDependentOnPeriodo(): void {
        this.entidadAuditoraEnabledForCA = false;
        this.setComunidadAutonoma(null);
        this.cleanDependentOnCA();
        this.setEntidadAuditora(null);
    }

    private cleanDependentOnCA(): void {
        this.setIdProvincia(null);
        this.setIdMunicipio(null);
        this.setIdOperador(null);
    }

    private setCampania(idCampania: number | null): void {
        this.formGroup.patchValue({
            IdCampania: idCampania,
        });
    }

    private setPeriodo(idPeriodo: number | null): void {
        this.formGroup.patchValue({
            IdPeriodo: idPeriodo,
        });
    }

    private setComunidadAutonoma(idCA: number | null): void {
        this.formGroup.patchValue({
            IdCA: idCA,
        });
    }

    private setEntidadAuditora(idEntidadAuditora: number | null): void {
        this.formGroup.patchValue({
            IdEntidadAuditora: idEntidadAuditora,
        });
    }

    private setIdProvincia(idProvincia: number | null): void {
        this.formGroup.patchValue({
            IdProvincia: idProvincia,
        });
    }

    private setIdMunicipio(idMunicipio: number | null): void {
        this.formGroup.patchValue({
            IdMunicipio: idMunicipio,
        });
    }

    private setIdOperador(idOperador: number | null): void {
        this.formGroup.patchValue({
            IdOperador: idOperador,
        });
    }

    /**
     * Para controlar la propiedad disabled del botón de reset.
     * @returns boolean
     */
    formIsUntouched(): boolean {
        return this.formGroup.pristine || !this.formGroup.dirty;
    }

    /**
     * Para controlar la propiedad disabled del botón de búsqueda.
     * Mientras no estén cargadas las campanias, no se habilita el botón.
     * @returns boolean
     */
    get disableSearchBtn(): boolean {
        return this.isCollapsed || !this.campanias || !this.estadosUnidadInspeccion || !this.tiposSolicitud;
    }
}
